export const reviewQuestions = [
  'Are these the same concepts used in other papers?',
  'Does the passage support the proposed relationship?',
  'Does the proposal follow the organization’s rules?',
  'Does an expert need to review it?',
  'Which source, reviewer, and version does the approved connection come from?',
]

export const toolChoices = [
  { need: 'Summarize a document or explore an idea quickly', use: 'An LLM', tool: 'llm' },
  { need: 'Suggest concepts and relationships from many documents', use: 'An LLM, with review', tool: 'llm' },
  { need: 'Maintain approved definitions and connections over time', use: 'SKP', tool: 'skp' },
  { need: 'Track sources, changes, reviewers, and permissions', use: 'SKP', tool: 'skp' },
  { need: 'Ask natural-language questions about approved knowledge', use: 'SKP and an LLM together', tool: 'both' },
]
